export default __webpack_public_path__ + "static/media/google_icon.d752f318.png";